import React, { useState } from "react";
import "../../assets/styles/auth/auth.css";
import Icon from "../../components/ui/icon";
import { NavLink } from "react-router-dom";
import { useToast } from "../../context/toastContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import HorizontalLogo from '../../assets/logos/horizontal-logo.png';

const LoginPage = () => {
  const [isTCChecked, setisTCChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoginBtnD, setIsLoginBtnD] = useState(false);
  const [emailID, setEmailID] = useState("");
  const [password, setPassword] = useState("");
  const showToast = useToast();
  const navigate = useNavigate();

  const sanitizeInput = (value) => DOMPurify.sanitize(value);

  const handelLoginBtn = () => {
    if (isLoginBtnD) return;
    setIsLoginBtnD(true);

    const sanitizedEmail = sanitizeInput(emailID);
    const sanitizedPaswword = sanitizeInput(password);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (sanitizedEmail.length <= 0) {
      document.getElementById("emailID").focus();
      navigator.vibrate([200]);
      setIsLoginBtnD(false);
      return;
    }

    if (!emailRegex.test(sanitizedEmail)) {
      document.getElementById("emailID").focus();
      navigator.vibrate([200, 100, 200]);
      setIsLoginBtnD(false);
      return;
    }

    if (sanitizedPaswword.length <= 0) {
      document.getElementById("password").focus();
      navigator.vibrate([200]);
      setIsLoginBtnD(false);
      return;
    }

    if (!isTCChecked) {
      showToast({
        status: "error",
        message: "Accept Our Conditions.",
      });
      setIsLoginBtnD(false);
      return;
    }

    axios
      .post(`${window.location.origin === 'http://localhost:3000' ? 'http://localhost:5500' : window.location.origin}/api/auth/login`, {
        email: sanitizedEmail,
        password: sanitizedPaswword,
      })
      .then((response) => {
        if (response.data.status) {
          showToast({
            status: "success",
            message: response.data?.message || "Login Successful.",
          });
          localStorage.setItem("aToken", response.data.token);
          if (response.data.userType === "employee" || response.data.userType === "admin") {
            navigate("/admin");
          } else {
            navigate("/");
          }
        } else {
          showToast({
            status: "error",
            message: response.data?.message || "Login Failed.",
          });
        }
      })
      .catch((error) => {
        showToast({
          status: "error",
          message: error.response?.data?.message || "Something went wrong.",
        });
      })
      .finally(() => {
        setIsLoginBtnD(false);
      });
  };

  return (
    <div className="login__page">
      <div className="company-info">
        <img src={HorizontalLogo} alt="Company Logo" />
        <h1>Swift Digital Ads</h1>
        <p>
          Someone who not just help you grow but also help you track your growth
        </p>
      </div>

      <div className="main-content">
        <h1>Welcome Back</h1>
        <p>Please enter your login details to login into your account.</p>

        <div className="login-form">
          <div className="inp-box">
            <label htmlFor="emailID">Email ID</label>
            <input
              value={emailID}
              onChange={(e) => setEmailID(e.target.value)}
              type="email"
              id="emailID"
              placeholder="eg: jhon@gmail.com"
            />
          </div>

          <div className="inp-box">
            <label htmlFor="password">Password</label>
            <div className="inp-with-btn">
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="*********"
              />
              <button onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <Icon name="EyeSlash" /> : <Icon name="Eye" />}
              </button>
            </div>
          </div>
        </div>

        <div className="tc-sec">
          <div
            onClick={() => setisTCChecked(!isTCChecked)}
            className={`tc-box ${isTCChecked ? "checked" : ""}`}
          >
            {isTCChecked && <Icon name="Check" />}
          </div>
          <p>I accept <a href="https://swiftdigitalads.com/doc/terms" target="_blank" rel="noreferrer">terms & conditions</a> and <a href="https://swiftdigitalads.com/doc/privacy" target="_blank" rel="noreferrer">privacy policy</a>.</p>
        </div>

        <button
          className="login-btn"
          onClick={handelLoginBtn}
          disabled={isLoginBtnD}
        >
          {isLoginBtnD ? (
            <>
              Checking... <Icon name="ArrowPath" className="icon-spin" />
            </>
          ) : (
            <>
              Login <Icon name="ChevronRight" />
            </>
          )}
        </button>

        <div className="divider">
          <div className="line"></div>
          <p className="text">Quick Links</p>
        </div>

        <div className="QuickLinks">
          <NavLink to="/auth/forget-password">Forget Password?</NavLink>
          <NavLink to="/auth/register">Register</NavLink>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
